/**
 * 检测图片是否存在
 * @param url
 */
export const imageIsExist = function(url) {
    return new Promise((resolve) => {
        var img = new Image();
        img.onload = function () {
            if (this.complete == true){
                resolve(true);
                img = null;
            }
        }
        img.onerror = function () {
            console.error(`Error:[圖片錯誤, 請檢查圖片路徑(綁定在 v-real-img 上)為 '${url}' 的圖片]`);
            resolve(false);
            img = null;
        }
        img.src = url;
    })
}